import { render } from "./TicketsView.vue?vue&type=template&id=67716126&scoped=true&ts=true"
import script from "./TicketsView.vue?vue&type=script&lang=ts"
export * from "./TicketsView.vue?vue&type=script&lang=ts"

import "./TicketsView.vue?vue&type=style&index=0&id=67716126&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67716126"]])

export default __exports__